import { useLoaderData } from 'react-router';
import { dsClass } from '../../../../../common/constants/dsClasses.js';
import { paths } from '../../../../../common/constants/pathVariables';
import { useSearchParams } from '../../../../../common/hooks/useSearchParams';
import { useTitle } from '../../../../../common/hooks/useTitle.js';
import { myOrdersMsg, omaElisaForEmployeeMsg, t } from '../../../../../common/i18n/index.js';
import { isAdminUser } from '../../../../../common/utils/accountUtils.js';
import { CustomerOrderListWithTable } from '../../../../../components/CustomerOrderList/CustomerOrderListWithTable';
import {
  EoeMyOrdersBreadcrumb,
  EoeMyOrdersNavi,
} from '../../../../../components/EoeMyOrdersWrapper/EoeMyOrdersWrapper.js';
import { Grid } from '../../../../../components/Grid/Grid.js';
import { useAuth } from '../../../AuthProvider';
import type { CustomerOrdersResponse } from '../../../../../generated/api/customerOrdersResponse';

export const EoeOwnOrdersPath = () => {
  const { authenticatedUser } = useAuth();
  const { searchResults, resultCountAggregations, total } = useLoaderData() as CustomerOrdersResponse;

  useTitle([t.H6JV(omaElisaForEmployeeMsg), t.EG6F(myOrdersMsg)]);

  const { search, status } = useSearchParams<{
    offset?: string;
    order?: string;
    search?: string;
    status?: string;
    sort?: string;
  }>();

  const isAdmin = isAdminUser(authenticatedUser);

  return (
    <>
      <EoeMyOrdersBreadcrumb />
      <EoeMyOrdersNavi />
      <Grid>
        <CustomerOrderListWithTable
          basePath={paths.EMPLOYEE_OWN_ORDER}
          customerOrders={searchResults}
          aggregations={resultCountAggregations}
          loading={false}
          totalItems={total}
          status={status}
          searchQuery={search}
          authenticatedUser={authenticatedUser}
          isAdmin={isAdmin}
        />
        <p className={dsClass.MARGIN_TOP_5}>
          <strong>{t.FZU3(`Can't you see your order here?`)}</strong>{' '}
          {t.QZZR('If you just placed it, no worries. The order will appear here with a little delay.')}
        </p>
      </Grid>
    </>
  );
};
